/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ severity: NonNullable<unknown>, message: NonNullable<unknown>, row: NonNullable<unknown> }} Import_Issue_Label_RowInputs */

const cs_import_issue_label_row = /** @type {(inputs: Import_Issue_Label_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.severity}: ${i?.message} (řádek ${i?.row})`)
};

const en_import_issue_label_row = /** @type {(inputs: Import_Issue_Label_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.severity}: ${i?.message} (row ${i?.row})`)
};

/**
* | output |
* | --- |
* | "{severity}: {message} (row {row})" |
*
* @param {Import_Issue_Label_RowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_issue_label_row = /** @type {((inputs: Import_Issue_Label_RowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Issue_Label_RowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_issue_label_row(inputs)
	return cs_import_issue_label_row(inputs)
});